import { BASE_URL, ENROLLMENT } from "constants/api";
import axios from "../helpers/axiosInstance";

export async function withdraw(workshopId: string) {
  const response = await axios.patch(BASE_URL + ENROLLMENT + "/" + workshopId);
  return response.data;
}

export async function getEnrollment(id: string) {
  const response = await axios.get(BASE_URL + ENROLLMENT + "/" + id);
  return response.data;
}

export async function getByWorkshopAndEmployee(workshopId: string, employeeId: string) {
  const response = await axios.get(BASE_URL + ENROLLMENT + "/" + workshopId + '/' + employeeId);
  return response.data;
}

export async function GetByInvitationGroupAndEmployee(invitationGroupId: string, employeeId: string) {
  const response = await axios.get(BASE_URL + ENROLLMENT + "/group/" + invitationGroupId + '/' + employeeId);
  return response.data;
}

export async function deleteWaitingList(id: string) {
const response = await axios.delete(BASE_URL + ENROLLMENT + "/deletewaitinglist/" + id);
  return response.data;
}
